module.exports = __webpack_public_path__ + "static/media/prayer-rope.36c9d3fb.png";